module.exports = __webpack_public_path__ + "static/media/comment-dots.311d17a8.svg";